module.exports = __webpack_public_path__ + "img/Andaluza-10-min.4e00d40c.jpg";